import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import DigitalBox from './digitalBox';
import FoBox from './foBox';

class DFNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { digitalData, foData, digitalAndFoAd },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <DigitalBox content={digitalData} />
                    <FoBox content={foData} />
                </div>
                {digitalAndFoAd ? <Ad content={digitalAndFoAd} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(DFNews);
